
import {
  ConnectedExchange,
  Exchange,
  ExchangeConnectionStatus,
} from "@/models/Exchange";
import { Component, Prop } from "vue-property-decorator";
import BasePortfolioStep from "./BasePortfolioStep.vue";

@Component({
  components: {
    ConnectExchangeForm: () =>
      import("@/components/exchange/ConnectExchangeForm.vue"),
  },
})
export default class ConnectExchange extends BasePortfolioStep {
  // 📦 The exchange on which the user want to base their investment portfolio
  @Prop()
  public selectedExchange!: Exchange;

  protected async mounted() {
    // Catch event for when the
    this.$store.subscribe((mutation, state) => {
      if (mutation.type == "publishExchangeConnected" && mutation.payload) {
        this.$store.dispatch("fetchAllExchanges");
        this.completeStep(
          new ConnectedExchange(
            mutation.payload,
            ExchangeConnectionStatus.CONNECTED,
            null
          )
        );
      }
    });
  }
}
